<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 section" id="about-the-author">
<h1>About the Author</h1>
<p>Very positive, always trying to find a solution to a problem even when in a lot of pain and not one for worrying either. Likes passing on positive experiences on to others. Always looks on the bright side of life and never gives in to anything. Strong-willed as well.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3b39ffb6